var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upsell-config" },
    [
      _c(
        "section",
        {
          staticClass: "upsell-config-plan",
          attrs: { id: "upsell-config-plan" }
        },
        [
          _c(
            "h4",
            {
              staticClass:
                "upsell-config__heading typographies-paragraph-x-large-semibold"
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$l10n.__("Plan")) + "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "upsell-config-plan__container" },
            _vm._l(_vm.plans, function(plan) {
              return _c(
                "li",
                {
                  key: plan.key,
                  class: [
                    "upsell-config-plan__item typographies-paragraph-medium-semibold",
                    _vm.planClasses(plan.key, plan)
                  ],
                  on: {
                    click: function($event) {
                      return _vm.updateSelectedPlan(plan)
                    }
                  }
                },
                [
                  _c("CompassTooltip", {
                    attrs: {
                      content: _vm.$t.__(
                        "pages.account.upsell.ChargebeeUpsellConfig.contact_sale_for_downgrade_plan"
                      ),
                      "content-class":
                        "upsell-config-plan__item-tooltip typographies-paragraph-small-regular",
                      disabled: plan.enabled,
                      placement: "bottom-start"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "upsell-config-plan__item-label" },
                    [_vm._v(_vm._s(plan.label))]
                  ),
                  _vm._v(" "),
                  _c("CompassRadio", {
                    attrs: {
                      "model-value": plan.key,
                      label: " ",
                      checked: plan.key === _vm.getPlanSelected,
                      disabled: !plan.enabled
                    },
                    on: {
                      change: function($event) {
                        return _vm.updateSelectedPlan(plan)
                      }
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "upsell-config-licenses",
          attrs: { id: "upsell-config-licenses" }
        },
        [
          _c(
            "h4",
            {
              staticClass:
                "upsell-config__heading typographies-paragraph-x-large-semibold"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Licences")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "upsell-config-licenses__container" },
            _vm._l(_vm.licenses, function(license) {
              return _c(
                "li",
                {
                  key: license.id,
                  staticClass: "upsell-config-licenses__item"
                },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(license.label) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upsell-config-licenses__item-price" },
                    [
                      _c("CompassNumberInput", {
                        attrs: {
                          disabled: _vm.getEstimationLoading,
                          "model-value": _vm.getSubscriptionLicenseQuantity(
                            license
                          ),
                          min: 0
                        },
                        on: {
                          change: function(newValue) {
                            return _vm.updateLicense(license.id, newValue)
                          }
                        }
                      }),
                      _vm._v(" "),
                      license.price
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "upsell-config-licenses__item-price-infos"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "typographies-paragraph-medium-semibold"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm._f("numberformatCurrency")(
                                          license.price / 100
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              license.period_unit
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "typographies-paragraph-small-regular"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            /" +
                                          _vm._s(
                                            _vm.recurrencyLabel(
                                              license.period_unit
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "upsell-config-options",
          attrs: { id: "upsell-config-options" }
        },
        [
          _c(
            "h4",
            {
              staticClass:
                "upsell-config__heading typographies-paragraph-x-large-semibold"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Options")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("ul", { staticClass: "upsell-config-options__container" }, [
            _vm.isOptionEnabled("pack_stock")
              ? _c("li", { staticClass: "upsell-config-options__item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "upsell-config-options__item-infos typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassSwitch", {
                        attrs: {
                          disabled: _vm.isOptionEnabled("pack_stock"),
                          value: _vm.isOptionEnabled("pack_stock")
                        },
                        on: {
                          input: function(value) {
                            return _vm.updateOption("pack_stock", value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "upsell-config-options__item-infos-content"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.options.pack_stock.label) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "upsell-config-options__item-infos-description"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Gardez une vision précise de vos stocks en temps réel"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("numberformatCurrency")(
                                _vm.options.pack_stock.price / 100
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                        /" +
                            _vm._s(
                              _vm.recurrencyLabel(
                                _vm.options.pack_stock.period_unit
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isOptionEnabled("pack_support")
              ? _c("li", { staticClass: "upsell-config-options__item" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "upsell-config-options__item-infos typographies-paragraph-medium-regular"
                    },
                    [
                      _c("CompassSwitch", {
                        attrs: {
                          disabled: _vm.isOptionEnabled("pack_support"),
                          value: _vm.isOptionEnabled("pack_support")
                        },
                        on: {
                          input: function(value) {
                            return _vm.updateOption("pack_support", value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "upsell-config-options__item-infos-content"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.options.pack_support.label) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "upsell-config-options__item-infos-description"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Assistez vos clients avec une gestion de ticket collaborative"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("numberformatCurrency")(
                                _vm.options.pack_support.price / 100
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                        /" +
                            _vm._s(
                              _vm.recurrencyLabel(
                                _vm.options.pack_support.period_unit
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass:
                  "upsell-config-options__item upsell-config-options__item--has-select"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "upsell-config-options__item-infos typographies-paragraph-medium-regular"
                  },
                  [
                    _c("CompassSwitch", {
                      attrs: { value: _vm.isOptionEnabled("pack_cashflow") },
                      on: {
                        input: function(value) {
                          return _vm.updateOption("pack_cashflow", value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upsell-config-options__item-infos-content"
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$l10n.__("Trésorerie")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "upsell-config-options__item-infos-description"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Visualisez votre trésorerie en temps réel et réalisez des prévisions"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "CompassSelect",
                          {
                            attrs: {
                              disabled: !_vm.isOptionEnabled("pack_cashflow"),
                              value: _vm.cashflowSelectValue.id
                            },
                            on: {
                              "update:value": function(value) {
                                return _vm.updateLevelOption({
                                  optionNameKey: "pack_cashflow",
                                  optionId: value
                                })
                              }
                            }
                          },
                          _vm._l(_vm.options.pack_cashflow, function(
                            selectOption
                          ) {
                            return _c("CompassDropdownSelectOption", {
                              key: selectOption.id,
                              attrs: {
                                label: selectOption.level,
                                value: selectOption.id,
                                caption: _vm.getCaptionSelectPrice(selectOption)
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "upsell-config-options__item-price" },
                  [
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-medium-semibold" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm._f("numberformatCurrency")(
                                _vm.humanizeCentsPrice(
                                  _vm.cashflowSelectValue.amount
                                )
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                         /" +
                            _vm._s(
                              _vm.recurrencyLabel(
                                _vm.cashflowSelectValue.period_unit
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.pricingVersion >= 5
        ? _c("ChargebeeUpsellMarketing", {
            attrs: { id: "upsell-config-marketing" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }